import CreatableReactSelect from '@atlaskit/react-select/creatable';
import createSelect from './createSelect';
var CreatableSelect = createSelect(CreatableReactSelect);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default CreatableSelect;